export default "__VITE_ASSET__CdwK8Vz9__"